<template>
  <div :class="['top-bar-wrap', menuOpen ? 'is-open': '',
                scrolled ? 'scrolled' : '']">
    <div class='top-bar row items-center justify-between'>
      <button :class="['hamburger hamburger--collapse', menuOpen ? 'is-active' : '']"
              type="button"
              @click="toggleMenu">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
      <router-link to="/">
        <div class="row no-wrap logo-wrap">
          <img src="@/assets/logo_feat_software_sign.png"
              class="logo-sign"
              alt="" />
          <img src="@/assets/logo_feat_software_text.png"
              class="logo-text"
              alt="" />
        </div>
        <div class="icons-social-media">
          <a href="https://www.facebook.com/featSoftware/"
            target="_blank">
            <i :class="['icon icon--fb', menuOpen || viewport.gt.xs ? 'icon--fb-green' : '']"></i>
          </a>
        </div>
      </router-link>
    </div>
    <div :class="['menu-wrap', menuOpen ? 'is-open' : '']">
      <div class="menu-scroller">
        <div v-if="viewport.lt.md"
             class="menu menu--lt-md">
          <div :class="['menu__item',
                         link.links && link.open ? 'has-open-submenu' : '']"
               v-for="(link, linkIndex) in links"
               :key="`menu-item-${linkIndex}`">
            <span class="menu__item-title"
                  @click="() => handleMenuItemClick(linkIndex)">
              {{link.title}}
            </span>
            <div v-if="link.links"
                 :class="['sub-menu', link.open ? 'is-open' : '']"
                 :style="{maxHeight: link.open ? `${link.maxHeight}px` : '0'}"
                 ref="submenus">
              <div v-for="(sublink, sublinkIndex) in link.links"
                   :key="`submenu-item-${sublinkIndex}`"
                   @click="() => redirect(sublink.to)"
                   class="sub-menu__item">
                {{sublink.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="viewport.gt.sm"
           class="menu--gt-sm">
        <div class="menu-left">
          <div class="menu">
            <div :class="['menu__item',
                           activeMenuItem === linkIndex && activeSubmenu ? 'is-active' : '']"
                 v-for="(link, linkIndex) in links"
                 :key="`menu-item-${linkIndex}`"
                 @mouseover="() => handleMenuItemHover(linkIndex)">
              <span class="menu__item-title"
                    @click="() => handleMenuItemClick(linkIndex)">
                {{link.title}}
              </span>
              <div class="arrow-wrap arrow--green">
                <div class="arrow-tail"></div>
                <div class="arrow-tip"></div>
              </div>
            </div>
          </div>
          <div class="sub-menu">
            <div v-for="(sublink, sublinkIndex) in activeSubmenu"
                 :key="`submenu-item-${sublinkIndex}`"
                 class="sub-menu__item"
                 :class="activeSubmenuItemIndex === sublinkIndex ? 'is-active' : ''">
              <span class="sub-menu__item-title"
                    @click="() => handleSubmenuItemClick(sublinkIndex)">
                {{sublink.title}}
              </span>
            </div>
          </div>
          <div class="sub-menu-item-img-row grow-1 row justify-center">
            <div
                v-for="(sublink, sublinkIndex) in activeSubmenu"
                :key="`submenu-item-img-wrap-${sublinkIndex}`"
                :class="['sub-menu-item-img-wrap',
                         activeSubmenuItemIndex === sublinkIndex ? 'is-active' : '']">
              <img class="sub-menu-item-img"
                   @click="redirect(sublink.to)"
                   :src="require(`@/assets/${sublink.img}`)"
                   alt="" />
            </div>
          </div>
        </div>
        <div class="menu-right">
          <ButtonCTA @click="redirect('/contact')"
                     color="white">
            Hire us
          </ButtonCTA>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'TopBar',
  data() {
    return {
      links: [
        {
          to: '/',
          title: this.$t('menu.home'),
        },
        {
          title: this.$t('menu.caseStudies'),
          open: false,
          links: [
            {
              to: '/case-study/nautilius',
              title: this.$t('menu.nautilius'),
              img: 'menu_nautilius.png',
            },
            {
              to: '/case-study/omega',
              title: this.$t('menu.omegaGroup'),
              img: 'menu_omega_group.png',
            },
            {
              to: '/case-study/omega-platform',
              title: this.$t('menu.omegaWeb'),
              img: 'menu_omega_platform.png',
            },
            // {
            //   to: '/case-study/omega-holding',
            //   title: this.$t('menu.omegaHolding'),
            // },
          ],
        },
        {
          to: '/about',
          title: this.$t('menu.about'),
        },
        {
          to: '/contact',
          title: this.$t('menu.contact'),
        },
      ],
      /* for viewports greater than sm */
      activeMenuItem: 0,
      activeSubmenuItemIndex: undefined,
    };
  },
  computed: {
    ...mapState('viewport', ['viewport', 'scroll']),
    ...mapState(['menuOpen']),
    activeSubmenu() {
      const { activeMenuItem, links } = this;
      const link = links[activeMenuItem];
      const { links: subLinks } = link;
      return subLinks;
    },
    activeSubmenuItem() {
      const { activeSubmenuItemIndex, activeSubmenu = [] } = this;
      return activeSubmenu[activeSubmenuItemIndex];
    },
    activeSubmenuItemImg() {
      const { activeSubmenuItemIndex, activeSubmenu } = this;
      if (
        !activeSubmenu
        || (!activeSubmenuItemIndex && activeSubmenuItemIndex !== 0)
      ) {
        return;
      }
      // eslint-disable-next-line
      return activeSubmenu[activeSubmenuItemIndex].img;
    },
    scrolled() {
      const { viewport, scroll } = this;
      return (
        (viewport.xs && scroll.y > 10) || (viewport.gt.xs && scroll.y > 30)
      );
    },
  },
  watch: {
    'viewport.name': {
      handler() {
        this.$nextTick(() => {
          this.calculateSubmenusMaxHeight();
        });
      },
    },
  },
  mounted() {
    const { calculateSubmenusMaxHeight } = this;
    calculateSubmenusMaxHeight();
  },
  methods: {
    ...mapMutations(['openMenu', 'hideMenu', 'toggleMenu']),
    handleMenuItemClick(linkIndex) {
      const { links, $router } = this;
      const link = links[linkIndex];
      const { open, links: subLinks } = link;
      const isSubmenu = !!subLinks;
      if (isSubmenu) {
        this.links[linkIndex].open = !open;
      } else {
        $router.push(link.to);
        this.hideMenu();
      }
    },
    calculateSubmenusMaxHeight() {
      const {
        $refs: { submenus },
        links,
        viewport,
      } = this;

      if (viewport.gt.sm) {
        return;
      }
      const maxHeights = [];
      /* eslint-disable */
      submenus.forEach(menu => {
        menu.style.maxHeight = "none";
        maxHeights.push(menu.offsetHeight);
        menu.style.maxHeight = "0";
      });
      /* eslint-enable */

      this.links = links.map((link) => {
        const { links: subLinks } = link;
        const isSubmenu = !!subLinks;
        if (isSubmenu) {
          const maxHeight = maxHeights.shift();
          console.log({ maxHeight });

          return {
            ...link,
            maxHeight,
          };
        }
        return link;
      });
    },
    handleMenuItemHover(index) {
      if (index === this.activeMenuItem) {
        return;
      }

      this.activeSubmenuItemIndex = undefined;
      this.activeMenuItem = index;
    },
    handleSubmenuItemClick(index) {
      if (index === this.activeSubmenuItemIndex) {
        return;
      }

      this.activeSubmenuItemIndex = index;
    },
    redirect(to) {
      this.$router.push(to);
      this.hideMenu();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '../styles/variables';

.grow-1 {
  flex-grow: 1;
}

.menu__item-title, .sub-menu__item {
  cursor: pointer;
  user-select: none;
}

.hamburger {
  z-index: 901;

  &:focus {
    outline: none;
  }
}

.menu-wrap {
  position: relative;
  transform: translateY(calc(-100% - 76px));
  transition: transform 0.6s;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transform: translateY(-100%);
    height: 76px;
    background: white;
    z-index: 899;
  }

  &.is-open {
    transform: translateY(0);
  }
}

.menu-scroller {
  max-height: calc(100vh - 76px);
  overflow-y: auto;
}

.menu {
  position: relative;
  z-index: 901;
  padding-top: 40px;
  padding-bottom: 35px;
  background: white;
  overflow-y: auto;
}

.menu, .sub-menu, .menu__item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.menu__item {
  margin-bottom: 45px;
  font-family: 'Dosis', sans-serif;
  font-weight: 200;
  font-size: 30px;
  line-height: 35px;
  color: #333;
  transition: color 0.3s;

  &.has-open-submenu {
    color: #4CB06A;
  }
}

.sub-menu {
  max-height: 0;
  transition: max-height 0.6s;
  overflow: hidden;
}

.sub-menu__item {
  &:first-child {
    padding-top: 35px;
  }

  &:not(:last-child) {
    margin-bottom: 30px;
  }

  font-size: 16px;
  font-weight: 200;
  line-height: 46px;
  font-family: 'Open Sans', sans-serif;
  color: #4C4C4C;
}

.top-bar-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-height: 76px;
}

.top-bar-wrap, .top-bar {
  z-index: 900;
}

.top-bar-wrap {
  &.is-open {
    .top-bar {
      .icons-social-media {
        transform: translateX(0);
        opacity: 1;
      }

      .logo-text {
        transform: translateX(-100%);
        opacity: 0;
      }

      .logo-wrap {
        opacity: 0;
      }
    }
  }
}

.top-bar {
  padding: 15px 40px 15px 25px;
  position: relative;

  &:before {
    content: '';
    background-image: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 75%);
    height: 107px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    transition: transform 0.3s;
    transform: translateY(-100%);
  }
}

.logo-wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-30%);
  transition: opacity 0.3s;
}

.logo-sign {
  margin-right: 13px;
  position: relative;
  transition: all 0.3s;
  left: 0;
  max-height: 21px;
}

.logo-text {
  transition: all 0.3s;
  max-height: 21px;
}

.icons-social-media {
  transform: translateX(calc(100% + 45px));
  transition: all 0.5s;
  opacity: 0;
  position: relative;
  top: 3px;

  .icon {
    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}

.top-bar-wrap {
  position: absolute;

  &.scrolled {
    position: fixed;

    .top-bar {
      padding-top: 0;

      .icons-social-media {
        transform: translateX(0);
        opacity: 1;
      }

      .logo-text {
        transform: translateX(-100%);
        opacity: 0;
      }

      &:before {
        transform: translateY(0);
        transition: transform 0.3s;
      }
    }
  }
}

@media (min-width: $breakpoint-sm-min) {
  .menu-wrap {
    transform: translateY(calc(-100% - 122.5px));

    &::before {
      height: 126px;
    }
  }

  .top-bar-wrap {
    &.scrolled {
      .top-bar {
        padding-top: 22.5px;

        .logo-sign {
          left: 50%;
          transform: translateX(-16px);
        }
      }
    }
  }

  .top-bar {
    padding-top: 55px;
    padding-bottom: 22.5px;

    .icons-social-media {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .top-bar-wrap {
    max-height: 101px;

    &.is-open {
      .logo-sign {
        left: 50%;
        transform: translateX(-16px);
      }
    }
  }

  .logo-wrap {
    transform: translateX(-50%);
  }

  .menu, .menu__item, .sub-menu {
    width: 100%;
  }

  .menu {
    padding-top: 60px;
    padding-bottom: 40px;
  }

  .menu__item {
    margin-bottom: 70px;
    font-size: 40px;
    line-height: 40px;
  }

  .sub-menu {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 600px;
  }

  .sub-menu__item {
    &:first-child, &:nth-child(2) {
      padding-top: 60px;
    }

    &:last-child, &:nth-last-child(2) {
      margin-bottom: 0;
    }

    width: 50%;
    display: flex;
    justify-content: center;
    margin-bottom: 35px;
  }
}

@media (min-width: $breakpoint-md-min) {
  .menu, .menu__item, .sub-menu__item, .sub-menu {
    width: auto;
  }

  .top-bar-wrap {
    .top-bar {
      padding-bottom: 22.5px;

      &:before {
        height: 100%;
        background: white;
        background: rgba(255, 255, 255, 0.85);
      }
    }
  }

  .top-bar-wrap {
    &.scrolled {
      .top-bar {
        padding-top: 22.5px;
      }
    }
  }

  .menu-wrap {
    background: white;
    transform: translateY(-100% - 101px);
  }

  .menu--gt-sm {
    max-width: 1120px;
    margin: 0 auto;
    padding-top: 25px;
    display: flex;
    justify-content: space-between;
  }

  .menu {
    padding: 0;
    max-width: 240px;
    width: 100%;
    max-height: none;
    overflow: hidden;
    padding-bottom: 135px;
  }

  .sub-menu {
    display: flex;
    flex-direction: column;
    padding-left: 40px;
  }

  .menu-left {
    display: flex;
    align-items: flex-start;
    flex-grow: 1;
  }

  .menu-right {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding-bottom: 135px;
  }

  .menu__item-title {
    transition: color 0.3s;
  }

  .menu__item-title:hover {
    color: #4cb06a;
  }

  .sub-menu__item-title {
    transition: color 0.3s;
  }

  .sub-menu__item {
    &.is-active {
      .sub-menu__item-title {
        color: #fca442;
      }
    }
  }

  .menu__item {
    font-size: 30px;
    line-height: 35px;
    margin-bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    overflow: visible;

    &:not(:last-child) {
      margin-bottom: 45px;
    }

    .arrow-wrap {
      opacity: 0;
      transform: translate(-200px, 320px);
      transition: transform 0.3s;
    }

    &.is-active {
      .arrow-wrap {
        opacity: 1;
        transform: translate(0, 0);
      }

      .menu__item-title {
        color: #4cb06a;
      }
    }
  }

  .sub-menu {
    max-height: none;
    max-width: 230px;
    width: 100%;
    z-index: 900;
  }

  .menu, .sub-menu {
    align-items: flex-start;
  }

  .sub-menu__item {
    &:first-child, &:nth-child(2) {
      padding-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:nth-last-child(2) {
      margin-bottom: 25px;
    }

    &:not(:last-child) {
      margin-bottom: 25px;
    }

    font-size: 16px;
    line-height: normal;
  }

  .sub-menu-item-img {
    max-height: 283px;
    max-width: 100%;
    cursor: pointer;
  }
  .sub-menu-item-img-row{
    position: relative;
  }
  .sub-menu-item-img-wrap {
    transform: translateX(-20%);
    transition: transform 0.3s;
    visibility: hidden;
    position: absolute;

    &.is-active {
      transform: translateX(0);
      visibility: visible;
    }
  }
}

@media (min-width: $breakpoint-lg-min) {
  .menu__item {
    font-size: 40px;
    line-height: 40px;

    &:not(:last-child) {
      margin-bottom: 65px;
    }
  }

  .sub-menu__item {
    font-size: 18px;

    &:not(:last-child) {
      margin-bottom: 45px;
    }
  }

  .menu {
    max-width: 275px;
  }

  .menu--gt-sm {
    max-width: 1520px;
  }

  .sub-menu {
    padding-left: 80px;
    max-width: 280px;
  }
}
</style>
